module.exports = __webpack_public_path__ + "static/media/consult_jur.38de1d30.svg";